import React, { useState } from 'react';
import { signUp, setupPractice } from '../firebase/auth'; 
import '../styling/practiceSetup.css'; 

const PracticeSetup = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [userInfo, setUserInfo] = useState({
    practiceName: '',
    officeAddress: '',
    officeCity: '',
    officeState: '',
    officeZipCode: '',
    officePhone: '',
    email: '',
    password: '',
    confirmPassword: ''
  });

  const practiceNames = [
    "FWOS", "Park Cities", "Sonoma County", "Hill & Ioppolo", "Ornstein", 
    "Saomsa", "Cosic", "Napa Sonoma", "Facial & Oral Surgery Associates",
    "Petaluma", "Antelope Valley", "Synergy", "Evergreen", "Three Rivers", 
    "Alameda", "Newhall", "WestsideOMS", "Oral Surgery Associates West Ten.",
    "Oral Surgery Associates", "Oregon Oral Surgeons", "Elevation Center", 
    "Peninsula Center", "Advanced Oral & Maxillofacial Surgery",
    "Integrative Oral & Facial Surgery", "Shroyer", "Memorial", "Paramount", 
    "Facial Surgery Institute"
  ];

  const handleUserInfoChange = (e) => {
    const { name, value } = e.target;
    setUserInfo(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const validateForm = () => {
    const requiredFields = [
      'practiceName', 'officeAddress', 'officeCity', 'officeState', 'officeZipCode', 
      'officePhone', 'email', 'password', 'confirmPassword'
    ];
    
    for (let field of requiredFields) {
      if (!userInfo[field]) {
        return false;
      }
    }
    return userInfo.password === userInfo.confirmPassword;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      if (!validateForm()) {
        throw new Error("Please fill in all fields and ensure passwords match");
      }

      const userCredential = await signUp(userInfo.email, userInfo.password);
      const userId = userCredential.user.uid;

      await setupPractice({
        practiceName: userInfo.practiceName,
        officeAddress: userInfo.officeAddress,
        officeCity: userInfo.officeCity,
        officeState: userInfo.officeState,
        officeZipCode: userInfo.officeZipCode,
        officePhone: userInfo.officePhone
      }, userId, userInfo.email);

      setUserInfo({
        practiceName: '',
        officeAddress: '',
        officeCity: '',
        officeState: '',
        officeZipCode: '',
        officePhone: '',
        email: '',
        password: '',
        confirmPassword: ''
      });

    } catch (error) {
      console.error("Error in practice setup:", error);
      setError(error.message || "An unknown error occurred during practice setup");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="practice-setup">
      <h1>Practice Profile Setup</h1>
      
      {error && <p className="error-message">{error}</p>}
      
      <form onSubmit={handleSubmit}>
        <label>
          Practice Name:
          <select
            name="practiceName"
            value={userInfo.practiceName}
            onChange={handleUserInfoChange}
            required
            className="input-field"
          >
            <option value="">Select a practice</option>
            {practiceNames.map((practice, index) => (
              <option key={index} value={practice}>{practice}</option>
            ))}
          </select>
        </label>
        <label>
          Office Address:
          <input
            type="text"
            name="officeAddress"
            value={userInfo.officeAddress}
            onChange={handleUserInfoChange}
            placeholder="Street"
            required
            className="input-field"
          />
          <input
            type="text"
            name="officeCity"
            value={userInfo.officeCity}
            onChange={handleUserInfoChange}
            placeholder="City"
            required
            className="input-field"
          />
          <input
            type="text"
            name="officeState"
            value={userInfo.officeState}
            onChange={handleUserInfoChange}
            placeholder="State"
            required
            className="input-field"
          />
          <input
            type="text"
            name="officeZipCode"
            value={userInfo.officeZipCode}
            onChange={handleUserInfoChange}
            placeholder="Zip Code"
            required
            className="input-field"
          />
        </label>
        <label>
          Office Phone Number:
          <input
            type="tel"
            name="officePhone"
            value={userInfo.officePhone}
            onChange={handleUserInfoChange}
            required
            className="input-field"
          />
        </label>
        <label>
          Email:
          <input
            type="email"
            name="email"
            value={userInfo.email}
            onChange={handleUserInfoChange}
            required
            className="input-field"
          />
        </label>
        <label>
          Password:
          <input
            type="password"
            name="password"
            value={userInfo.password}
            onChange={handleUserInfoChange}
            required
            className="input-field"
          />
        </label>
        <label>
          Confirm Password:
          <input
            type="password"
            name="confirmPassword"
            value={userInfo.confirmPassword}
            onChange={handleUserInfoChange}
            required
            className="input-field"
          />
        </label>
        <button type="submit" disabled={loading}>
          {loading ? 'Processing...' : 'Setup Practice'}
        </button>
      </form>
    </div>
  );
};
export default PracticeSetup;
